/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_InflowInputs */

const vi_cashflow_inflow = /** @type {(inputs: Cashflow_InflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vào`)
};

/**

* @param {Cashflow_InflowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_inflow = /** @type {((inputs?: Cashflow_InflowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_InflowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_inflow(inputs)
});